export const ENABLE_REDESIGN_TOP_SPONSORED_PRODUCT =
  'enableRedesignTopSponsoredProduct';
